import _ from 'lodash';

/**
 * Function will invalidate and update the cached transformed coverages
 * @public
 */
function updateModel() {
    if (this.offerings.length > 0) {
        this.lineCoverageArray = _transformLineCoveragesToArray(this.offerings);
        this.additionalCoverageArray = _transformAdditionalCoveragesToArray(this.offerings);
        this.schedulesArray = this.offerings.map(function (offering) {
            return {
                branch: offering.branchCode,
                schedules: offering.coverages.schedules
            };
        });
    }
}

/**
 * Transforms the submissions offerings from a complex object to another object simpler for rendering
 * @param  {Array} offerings - array of submissions LOB offerings
 * @returns {Object} - Object where each value is an array of coverages of the same type, sorted by offering
 * @private
 */
function _transformLineCoveragesToArray(offerings) {
    /*
     Add branch name to each coverage and flatten to array. Sort by branch and then group by Coverages.
     The end result is an object with each key as coverage ID. Each value is an array of coverages where the elements
     are sorted by their branch.
     Eg. {
     HoLineCov1: [ BaseCov1Branch1, BaseCov1Branch2, BaseCov1Branch3],
     HoLineCov2: [ BaseCov2Branch1, BaseCov2Branch2, BaseCov2Branch3],
     }
     */
    var lineCoverages = _(offerings).map(function (offering) {
        offering.coverages.baseCoverages.forEach(function (coverage) {
            coverage.branch = offering.branchCode;
        });
        return offering.coverages.baseCoverages;
    }).flatten();
    lineCoverages = lineCoverages.sortBy(function (offering) {
        return offering.branch;
    });
    return lineCoverages.groupBy(function (coverage) {
        return coverage.publicID;
    }).value();
}

/**
 * Transforms the submission offerings from a complex object to another object for simpler rendering
 * @param {Array} offerings - array of submissions LOB offerings
 * @returns {Object} - Object where each value is an array of coverages of the same type, sorted by offering
 * @private
 */
function _transformAdditionalCoveragesToArray(offerings) {
    /*
     Add branch name to each coverage and flatten to array. Sort by branch and then group by Coverages.
     The end result is an object with each key as coverage ID. Each value is an array of coverages where the elements
     are sorted by their branch.
     Eg. {
     HoLineCov1: [ AddCov1Branch1, AddCov1Branch2, AddCov1Branch3],
     HoLineCov2: [ AddCov2Branch1, AddCov2Branch2, AddCov2Branch3],
     }
     */
    var lineCoverages = _(offerings).map(function (offering) {
        offering.coverages.additionalCoverages.forEach(function (coverage) {
            coverage.branch = offering.branchCode;
        });
        return offering.coverages.additionalCoverages;
    }).flatten();
    lineCoverages = lineCoverages.sortBy(function (offering) {
        return offering.branch;
    });
    return lineCoverages.groupBy(function (coverage) {
        return coverage.publicID;
    }).value();
}

export default {
    updateModel: updateModel
};


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./common/js/src/edge/quoteandbind/ho/directives/HoOfferingSelection/defaultQuoteView/modelExtension/MultipleOfferingViewModelExtension.js
// module id = 476
// module chunks = 0